import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import '../css/HomeMini.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'


class HomeVehicle extends React.Component {
  constructor(props) {
    super(props);

    this.percentage = this.percentage.bind(this)

  }


  percentage(percent){
    return(
      <div className="avatar-content">
      <div className="tooltip">
        <i className="fa fa-caret-up font-medium-1" style={{ color: '#28c76f' }}>&nbsp;{percent}%</i>
        <span class="tooltiptext">increase/decrease from same time period last month</span>
      </div>
    </div>
    )
  }

  render() {
    return (

      <Card className="border border-secondary rounded p-1">
        <Card.Header className="text-center">
        </Card.Header>
        <Card.Body>
          <div className={this.props.cssName}>
            <i className={this.props.Icon} />
          </div>
          <h4 className="text-bold-700 mt-2">{this.props.quantityPrice}</h4>
          
          <p className="mb-0 line-ellipsis">{this.props.description}</p>
        </Card.Body>
      </Card>


    );
  }
}

export default HomeVehicle;